/* eslint-disable no-undef */
import { useFabricStore } from "@/stores/fabricModule";
import { useConfigurationStore } from '@/stores/configurationModule';
import customFabric from '@/fabric/index';
const {
  createFabricObject
} = customFabric;

// @NOTE: Used to add unsplash image

/**
 * @param {Object} file
 */
export async function useCreateEditorImage(file) {
  const {
    src,
    id,
    originalSource
  } = file;
  const fabricStore = useFabricStore();
  const configurationStore = useConfigurationStore();
  const {
    canvasWidth,
    canvasHeight
  } = storeToRefs(fabricStore);
  const {
    activePanel
  } = storeToRefs(configurationStore);
  const imgObj = {
    ...file
  };
  const options = {};

  // @TODO: Better check if file that's being added is new or from configuration
  if (!file.version) {
    const top = canvasHeight.value / 2;
    const left = canvasWidth.value / 2;

    /**
     * @TODO: NO_ACTIVE_PANEL_SCALE_COMPENSATION should be calculated based on canvas size
     * We want to get consistent image size across different box sizes when adding image to canvas
     * RETHINK
     */
    const NO_ACTIVE_PANEL_SCALE_COMPENSATION = 4; // 1/4 of canvas w and h
    const maxWidth = activePanel.value?.widthPx || canvasWidth.value / NO_ACTIVE_PANEL_SCALE_COMPENSATION;
    const maxHeight = activePanel.value?.heightPx || canvasHeight.value / NO_ACTIVE_PANEL_SCALE_COMPENSATION;
    imgObj.objectType = 'img'; // custom property
    imgObj.id = id;
    imgObj.originalSource = originalSource;
    imgObj.src = file.src;
    imgObj.top = top;
    imgObj.left = left;
    imgObj.originalSource = src;
    imgObj.type = file.type || 'image';
    options.maxHeight = maxHeight;
    options.maxWidth = maxWidth;
  }
  const i = await createFabricObject(imgObj, options);
  return i;
}